import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss']
})
export class AlertComponent implements OnInit {
  closebtn: any = 'flex';
  displaydata: any;
  backgroundColor: any = "#28a745";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly dialogRef: MatDialogRef<AlertComponent>
  ) {}

  ngOnInit(): void {
    this.displaydata = this.data.data;
    if (this.data.status == "Warning") {
      this.backgroundColor = "#ffeeba";
    }
    else if (this.data.status == "Error") {
      this.backgroundColor = "#f5c6cb";
    }
    else if (this.data.status == "Success") {
      this.backgroundColor = "#c3e6cb";
    }
  }

  close(): void {
    this.dialogRef.close();
  }
}
